
import React, { memo, useCallback, useEffect, useMemo, useState } from "react"

const estilosInputs = require('../../estilos/inputs.module.scss').default
const estilosTotalizador = require('./totalizador.module.scss').default
import clsx from 'clsx'
import { IOrcamento } from "app/types/IOrcamento"
import globalMU from "globalMU"
import { InputNumerico } from "../inputs/InputNumerico"
import { CanalDeVenda, MotivoDesconto } from "app/types/orcamento/MotivoDesconto"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { faPix } from "@fortawesome/free-brands-svg-icons/faPix";
import { ParametroPorItem } from "app/types/Parametro"


export type TotalizadorProps = {
    orcamento: IOrcamento
    separarNacionalImportado: boolean
    exibirPercentualDescontoAcumulado: boolean
    exibirDescontoAcumulado: boolean
    exibirAcrescimoFinanceiro: boolean
    exibirSubstituicao: boolean
    exibirValorIPI: boolean
    exibirDadosDeQuantidadePendente: boolean
    aceitarProdutoSemEstoque: boolean
    exibirMotivoDesconto: boolean
    exibirValorServicosAgregados: boolean // 447380
    exibirCanalDeVenda: boolean // 422642
    editarCanalDeVenda: boolean // 422642

    numeroCasasDecimais: number
    parametrosPorFilial?: ParametroPorItem[] // 414608

    desativarPercentualDescontoMercadoriasNacionais: boolean
    desativarValorDescontoMercadoriasNacionais: boolean
    desativarPercentualDescontoMercadoriasImportadas: boolean
    desativarValorDescontoMercadoriasImportadas: boolean
    desativarDespesasInclusas: boolean
    desativarPercentualSeguro: boolean
    desativarValorSeguro: boolean
    desativarValorFrete: boolean
    desativarPercentualDesconto: boolean
    desativarValorDesconto: boolean
    desativarPercentualDescontoAcumulado: boolean
    desativarValorDescontoAcumulado: boolean
    desativarAcrescimoFinanceiro: boolean
    desativarValorDescontoAcumuladoMercadoriasNacionais: boolean
    desativarValorDescontoAcumuladoMercadoriasImportadas: boolean
    desativarPercentualDescontoAcumuladoMercadoriasNacionais: boolean
    desativarPercentualDescontoAcumuladoMercadoriasImportadas: boolean
    desativarValorIPI: boolean
    desativarMotivoDesconto: boolean
    desativarCanalDeVenda: boolean
    trabalhaComFretePercentualNoOrcamento?: boolean // 445689
    desativarValorServicoAgregado: boolean

    motivosDesconto: MotivoDesconto[]

    onPercentualDescontoMercadoriasNacionaisModificado: (percentualDescontoMercadoriasNacionais: number) => void
    onValorDescontoMercadoriasNacionaisModificado: (valorDescontoMercadoriasNacionais: number) => void
    onValorDescontoAcumuladoNacionalModificado: (valor: number) => void
    onPercentualDescontoAcumuladoNacionalModificado: (valor: number) => void
    onPercentualDescontoAcumuladoImportadoModificado: (percentual: number) => void
    onPercentualDescontoMercadoriasImportadasModifcado: (percentualDescontoMercadoriasImportadas: number) => void
    onValorDescontoAcumuladoImportadoModificado: (valor: number) => void
    onValorDescontoMercadoriasImportadasModificado: (valorDescontoMercadoriasImportadas: number) => void
    onDespesasInclusasModificado: (despesasInclusas: number) => void
    onValorSeguroModificado: (valorSeguro: number) => void
    onPercentualSeguroModificado: (percentualSeguro: number) => void
    onValorFreteModificado: (valorFrete: number) => void
    onPercentualDescontoAcumuladoModificado: (percentualDescontoAcumulado: number) => void
    onPercentualDescontoModificado: (percentualDesconto: number) => void
    onValorDescontoAcumuladoModificado: (valorDescontoAcumulado: number) => void
    onValorDescontoModificado: (valorDesconto: number) => void
    onValorAcrescimoFinanceiroModificado: (valorAcrescimoFinanceiro: number) => void
    exibirDescontoAcumuladoNacionalEImportado: boolean
    onMotivoDescontoSelecionado: (codigoMotivoDesconto: number) => void
    onAplicarDescontoCashback: (aplicarDesconto: boolean) => void
    onPercentualFreteModificado: (percentualFrete: number) => void // 445689
    onValorServicosAgregadosModificado: (valorFrete: number) => void
    onCanalDeVendaSelecionado: (idCanalDeVenda: number) => void // 422642
    listaCanalDeVenda: CanalDeVenda[] // 422642
}

export const Totalizador = memo((props: TotalizadorProps) => {

    
    // 414536
    const [valorDesconto, setValorDesconto] = useState(props.orcamento.ValorDesconto) // 414536
    const [codigoMotivoDesconto, setCodigoMotivoDesconto] = useState(props.orcamento.CodigoMotivoDesconto) // 414536
    const [idCanalDeVenda, setIdCanalDeVenda] = useState(props.orcamento.IdCanalDeVenda) // 414536
    const somenteLeitura = props.orcamento.SomenteLeitura || globalMU.isNotNullOrEmpty(props.orcamento.CodigoDAV)

    const LimiteCreditoCliente = props.orcamento?.LimiteCreditoCliente;
    const LimiteCreditoClienteBloqueado = props.orcamento?.LimiteCreditoClienteBloqueado === "BLOQUEADO";
    const LimiteCreditoClientePendenciaFinanceira = props.orcamento?.LimiteCreditoClientePendenciaFinanceira;

/*
    const onValorDescontoModificado = (valor: number) => { // 414536
        setValorDesconto(valor)
        props.onValorDescontoModificado(valor)
    }

    useEffect(() => { // 414536
        if (props.orcamento.ValorDesconto != valorDesconto)
            setValorDesconto(props.orcamento.ValorDesconto)
    })
*/
    // Memoize handlers
    const handleValorDesconto = useCallback((valor: number) => {  // 414536
        setValorDesconto(valor);
        props.onValorDescontoModificado(valor);
    }, [props.onValorDescontoModificado]);

    useEffect(() => {  // 414536
        
        if (props.orcamento.ValorDesconto !== valorDesconto) {
            setValorDesconto(props.orcamento.ValorDesconto);
        }
    }, [props.orcamento.ValorDesconto])


    const valorParametroPorFilial = useCallback(
            (nome: string) => props.parametrosPorFilial.find(p => p.Nome === nome)?.Valor,
            [props.parametrosPorFilial]
        ) // 414608


    const dadosNacional = <>
        <span className={estilosTotalizador.legendaNegrito}>
            Nacional
        </span>
        <div></div>

        <span className={estilosTotalizador.subItem}>Mercadorias</span>
        <div>
            <input className={clsx(estilosInputs.inputPadrao, estilosTotalizador.input, "no-global-input")}
                id="Totalizador_ValorTotalMercadoriasNacionais"
                value={(globalMU.formatarValorNumerico(props.orcamento.ValorTotalMercadoriasNacionais, 2, true)) ?? ""}
                readOnly disabled={true} />
        </div>

        <span className={estilosTotalizador.subItem}>% Descon<u>t</u>o</span>
        <div>
            <InputNumerico
                onValorModificado={props.onPercentualDescontoMercadoriasNacionaisModificado}
                id="Totalizador_PercentualDescontoMercadoriasNacionais"
                valor={props.orcamento.PercentualDescontoSobreMercadoriasNacionais}
                classesInput={[estilosTotalizador.input]}
                numeroCasasDecimais={props.numeroCasasDecimais}
                disabled={props.desativarPercentualDescontoMercadoriasNacionais || somenteLeitura || props.orcamento.ValorDescontoIcms> 0}
                teclaDeAtalho="t"
                selecionaValorOnFocus={true} />
        </div>

        <span className={estilosTotalizador.subItem}>Desconto</span>
        <div>
            <InputNumerico
                onValorModificado={props.onValorDescontoMercadoriasNacionaisModificado}
                id="Totalizador_ValorDescontoMercadoriasNacionais"
                valor={props.orcamento.ValorDescontoSobreMercadoriasNacionais}
                classesInput={[estilosTotalizador.input]}
                numeroCasasDecimais={props.numeroCasasDecimais}
                disabled={somenteLeitura || props.desativarValorDescontoMercadoriasNacionais  || props.orcamento.ValorDescontoIcms> 0}
                selecionaValorOnFocus={true} />
        </div>

        {
            props.exibirDescontoAcumuladoNacionalEImportado && <>
                <span className={estilosTotalizador.subItem}>Desconto Acumulado</span>
                <div>
                    <InputNumerico
                        onValorModificado={props.onValorDescontoAcumuladoNacionalModificado}
                        id="Totalizador_ValorDescontoAcumuladoNacional"
                        valor={props.orcamento.ValorDescontoAcumuladoSobreMercadoriasNacionais ?? 0}
                        classesInput={[estilosTotalizador.input]}
                        numeroCasasDecimais={props.numeroCasasDecimais}
                        disabled={somenteLeitura || props.desativarValorDescontoAcumuladoMercadoriasNacionais || props.orcamento.ValorDescontoIcms> 0}
                        selecionaValorOnFocus={true}
                    />
                </div>
            </>
        }

        {
            props.exibirDescontoAcumuladoNacionalEImportado && <>
                <span className={estilosTotalizador.subItem}>% Desconto Acumulado</span>
                <div>
                    <InputNumerico
                        onValorModificado={props.onPercentualDescontoAcumuladoNacionalModificado}
                        id="Totalizador_PercentualDescontoAcumuladoNacional"
                        valor={props.orcamento.PercentualDescontoAcumuladoSobreMercadoriasNacionais ?? 0}
                        classesInput={[estilosTotalizador.input]}
                        numeroCasasDecimais={props.numeroCasasDecimais}
                        disabled={somenteLeitura || props.desativarPercentualDescontoAcumuladoMercadoriasNacionais || props.orcamento.ValorDescontoIcms> 0}
                        selecionaValorOnFocus={true}
                    />
                </div>
            </>
        }
    </>

    const dadosImportado = <>
        <span className={estilosTotalizador.legendaNegrito}>
            Importado
        </span>
        <div></div>

        <span className={estilosTotalizador.subItem}>Mercadorias</span>
        <div>
            <input className={clsx(estilosInputs.inputPadrao, estilosTotalizador.input, "no-global-input")}
                id="Totalizador_ValorTotalMercadoriasImportadas"
                value={(globalMU.formatarValorNumerico(props.orcamento.ValorTotalMercadoriasImportadas, 2, true)) ?? ""}
                readOnly disabled={true} />
        </div>

        <span className={estilosTotalizador.subItem}>% Desconto</span>
        <div>

            <InputNumerico
                onValorModificado={props.onPercentualDescontoMercadoriasImportadasModifcado}
                id="Totalizador_PercentualDescontoMercadoriasImportadas"
                valor={props.orcamento.PercentualDescontoSobreMercadoriasImportadas}
                classesInput={[estilosTotalizador.input]}
                numeroCasasDecimais={props.numeroCasasDecimais}
                disabled={somenteLeitura || props.desativarPercentualDescontoMercadoriasImportadas || props.orcamento.ValorDescontoIcms> 0}
                selecionaValorOnFocus={true} />
        </div>

        <span className={estilosTotalizador.subItem}>Desconto</span>
        <div>
            <InputNumerico
                onValorModificado={props.onValorDescontoMercadoriasImportadasModificado}
                id="Totalizador_ValorDescontoMercadoriasImportadas"
                valor={props.orcamento.ValorDescontoSobreMercadoriasImportadas}
                classesInput={[estilosTotalizador.input]}
                numeroCasasDecimais={props.numeroCasasDecimais}
                disabled={somenteLeitura || props.desativarValorDescontoMercadoriasImportadas || props.orcamento.ValorDescontoIcms> 0}
                selecionaValorOnFocus={true} />
        </div>

        {
            props.exibirDescontoAcumuladoNacionalEImportado && <>
                <span className={estilosTotalizador.subItem}>Desconto Acumulado</span>
                <div>
                    <InputNumerico
                        onValorModificado={props.onValorDescontoAcumuladoImportadoModificado}
                        id="Totalizador_ValorDescontoAcumuladoImportado"
                        valor={props.orcamento.ValorDescontoAcumuladoSobreMercadoriasImportadas ?? 0}
                        classesInput={[estilosTotalizador.input]}
                        numeroCasasDecimais={props.numeroCasasDecimais}
                        disabled={somenteLeitura || props.desativarValorDescontoAcumuladoMercadoriasImportadas || props.orcamento.ValorDescontoIcms> 0}
                        selecionaValorOnFocus={true}
                    />
                </div>
            </>
        }

        {
            props.exibirDescontoAcumuladoNacionalEImportado && <>
                <span className={estilosTotalizador.subItem}>% Desconto Acumulado</span>
                <div>
                    <InputNumerico
                        onValorModificado={props.onPercentualDescontoAcumuladoImportadoModificado}
                        id="Totalizador_PercentualDescontoAcumuladoImportado"
                        valor={props.orcamento.PercentualDescontoAcumuladoSobreMercadoriasImportadas ?? 0}
                        classesInput={[estilosTotalizador.input]}
                        numeroCasasDecimais={props.numeroCasasDecimais}
                        disabled={somenteLeitura || props.desativarPercentualDescontoAcumuladoMercadoriasImportadas || props.orcamento.ValorDescontoIcms> 0}
                        selecionaValorOnFocus={true}
                    />
                </div>
            </>
        }
    </>
    
    const dadosOrcamento = <>

        {props.orcamento.Numero > 0 && 
        <span 
            className={estilosTotalizador.legendaNegrito} 
            id="Totalizador_NumeroPedido"
        >
            Número: &nbsp;
                <span 
                    className={estilosTotalizador.legendaNegrito} 
                    style={{ color: !props.orcamento.SomenteLeitura && props.orcamento.EditandoSemRecalcular ? 'red' : null}} // 455487
                    title={props.orcamento.SomenteLeitura && props.orcamento.EditandoSemRecalcular ? 'Orçamento sendo editado sem recalcular' : null} // 455487
                    id="Totalizador_NumeroPedido"
                >
                    {props.orcamento.Numero}
                </span>
        </span>}

        {globalMU.isNotNullOrEmpty(props.orcamento.CodigoDAV) && <div>
            <span className={estilosTotalizador.legendaNegrito} id="Totalizador_NumeroDav">
                Nº do DAV: &nbsp;
            </span>
            <span>
                {props.orcamento.CodigoDAV}
            </span>
        </div>}

        <div>
            <span id="Totalizador_FilialOrcamento">
                {props.orcamento.FilialOrcamento}
            </span></div>

        {props.orcamento.Numero > 0 && <div>
            <div>
                <span className={estilosTotalizador.legendaNegrito} id="Totalizador_Vendedor">
                    Vendedor: &nbsp;
                </span>

                <span>
                    {props.orcamento.Vendedor.Nome}
                </span>
            </div>

            <div>
                <span className={estilosTotalizador.legendaNegrito} id="Totalizador_SituacaoOrcamento">
                    Situação: &nbsp;
                </span>

                <span>
                    {props.orcamento.DescricaoSituacao}
                </span>
            </div>

        </div>}
        <>{props.orcamento.TipoOrcamentoDescricao == "Venda" && valorParametroPorFilial("UTILIZA_RELACIONAMENTO_FILIAL_VENDEDOR_FONTE_RECEITA") == "S" && 
                <div>
                    <span className={estilosTotalizador.legendaNegrito} 
                        id="Totalizador_FonteDeReceita"
                        title="Veja parâmetro: Utiliza relacionamento de filial e vendedor por fonte de receita?"
                    >
                        Fonte de Receita: &nbsp;
                    </span>

                    <span
                        id="Totalizador_FonteDeReceita"
                    >
                        {props.orcamento.NomeFonteReceita}
                    </span>
                </div>
           }</>

    </>

    const titulo = <div className={estilosTotalizador.titulo}>
        Total
    </div>

    const quantidadeItens = <>
        <span>
            Quant. Itens
        </span>
        <div>
            <input
                className={clsx(estilosInputs.inputPadrao, estilosTotalizador.input, "no-global-input")}
                id="Totalizador_QuantidadeItens"
                value={(props.orcamento.ItensOrcamento ?? []).length}
                readOnly disabled={true} />
        </div>
    </>

    const valorMercadorias = <>
        <span>
            Mercadorias
        </span>
        <div>
            <input className={clsx(estilosInputs.inputPadrao, estilosTotalizador.input, "no-global-input")}
                id="Totalizador_ValorTotalMercadorias"
                value={(globalMU.formatarValorNumerico(props.orcamento.ValorTotalMercadorias, 2, true)) ?? ""}
                readOnly disabled={true} />
        </div>
    </>

    const separador = <>
        <hr />
        <hr />
    </>

    const valorDescontoIcms = <>
        <span 
            title="Desconto de ICMS (Orgão Público)"
            id="Totalizador_ValorDescontoIcmsOrgaoPublicoLabel"
        >
            Desconto ICMS
        </span>
        <div>
            <input className={clsx(estilosInputs.inputPadrao, estilosTotalizador.input, "no-global-input")}
                readOnly disabled={true || props.orcamento.ValorDescontoIcms> 0} // 467371
                id="Totalizador_ValorDescontoIcms"
                value={(globalMU.formatarValorNumerico(props.orcamento.ValorDescontoIcms, 2, false)) ?? ""} />
        </div>
    </>

    const valorDescontoIcmsDesonerado = <> 
        <span // 428915/313149
            id="Totalizador_ValorDescontoIcmsDesoneradoLabel"
            title="Valor do Desconto ICMS Desonerado"
        >
            Desconto ICMS
        </span>
        <div>
            <input className={clsx(estilosInputs.inputPadrao, estilosTotalizador.input, "no-global-input")}
                readOnly disabled={true} // 428915/313149
                id="Totalizador_ValorDescontoIcmsDesonerado"
                value={(globalMU.formatarValorNumerico(props.orcamento.ValorDescontoIcmsDesonerado, 2, false)) ?? ""} />
        </div>
    </>

    const despesasInclusasComponent = <>
        <span>
            Despesas Inclusas
        </span>
        <div>
            <InputNumerico
                onValorModificado={props.onDespesasInclusasModificado}
                id="Totalizador_DespesasInclusas"
                valor={props.orcamento.ValorDespesasInclusas}
                classesInput={[estilosTotalizador.input]}
                numeroCasasDecimais={props.numeroCasasDecimais}
                disabled={somenteLeitura || props.desativarDespesasInclusas}
                selecionaValorOnFocus={true}

            />
        </div>
    </>

    const percentualDesconto = <>
        <span>
            % Descon<u>t</u>o
        </span>
        <div>
            <InputNumerico
                onValorModificado={props.onPercentualDescontoModificado}
                id="Totalizador_PercentualDesconto"
                valor={props.orcamento.PercentualDesconto}
                classesInput={[estilosTotalizador.input]}
                numeroCasasDecimais={props.numeroCasasDecimais}
                disabled={somenteLeitura || props.desativarPercentualDesconto || props.orcamento.ValorDescontoIcms> 0}
                teclaDeAtalho="t"
                selecionaValorOnFocus={true}
            />
        </div>
    </>

    const campoValorDesconto = <>
        <span>
            Desconto
        </span>
        <div>
            <InputNumerico
                onValorModificado={handleValorDesconto} //414536
                id="Totalizador_ValorDesconto"
                valor={valorDesconto}
                classesInput={[estilosTotalizador.input]}
                numeroCasasDecimais={props.numeroCasasDecimais}
                disabled={somenteLeitura || props.desativarValorDesconto || props.orcamento.ValorDescontoIcms> 0}
                selecionaValorOnFocus={true} />
        </div>
    </>

    const percentualDescontoAcumuladoComponent = <>
        <span 
            title="% Desconto Acumulado&#013;Veja parâmetro: &#013;-Aplicar o percentual de desconto geral sobre o preço unitário básico de venda"
        >
            % Desc. Acumulado
        </span>
        <div>

            <InputNumerico
                onValorModificado={props.onPercentualDescontoAcumuladoModificado}
                id="Totalizador_PercentualDescontoAcumulado"
                valor={props.orcamento.PercentualDescontoAcumulado}
                classesInput={[estilosTotalizador.input]}
                numeroCasasDecimais={props.numeroCasasDecimais}
                disabled={somenteLeitura || props.desativarPercentualDescontoAcumulado || props.orcamento.ValorDescontoIcms> 0}
                selecionaValorOnFocus={true} />
        </div>
    </>

    const descontoAcumulado = <>
        <span>
            Desconto Acumulado
        </span>
        <div>

            <InputNumerico
                onValorModificado={props.onValorDescontoAcumuladoModificado}
                id="Totalizador_ValorDescontoAcumulado"
                valor={props.orcamento.DescontoAcumulado}
                classesInput={[estilosTotalizador.input]}
                numeroCasasDecimais={props.numeroCasasDecimais}
                disabled={somenteLeitura || props.desativarValorDescontoAcumulado || props.orcamento.ValorDescontoIcms> 0}
                selecionaValorOnFocus={true} />
        </div>
    </>

    const acrescimoFinanceiro = <>
        <span>
            Acréscimo Financeiro
        </span>
        <div>

            <InputNumerico
                onValorModificado={props.onValorAcrescimoFinanceiroModificado}
                id="Totalizador_ValorAcrescimoFinanceiro"
                valor={props.orcamento.ValorAcrescimoFinanceiro}
                classesInput={[estilosTotalizador.input]}
                numeroCasasDecimais={props.numeroCasasDecimais}
                disabled={somenteLeitura || props.desativarAcrescimoFinanceiro}
                selecionaValorOnFocus={true}
                style={{ color: props.orcamento.PendenciaAcrescimoFinanceiro ? "red" : "inherit" }}
            />
        </div>
    </>

    const substituicao = <>
        <span title="Valor da Substituição Tributária">
            Subst. Tributária
        </span>
        <div>
            <input className={clsx(estilosInputs.inputPadrao, estilosTotalizador.input, "no-global-input")}
            id="Totalizador_ValorSubstituicao"
                value={(globalMU.formatarValorNumerico(props.orcamento.ValorSubstituicao, 2, false)) ?? ""}
                readOnly disabled={true} />
        </div>
    </>

    const valorIPI = <>
        <span>
            Valor IPI
        </span>
        <div>
            <input className={clsx(estilosInputs.inputPadrao, estilosTotalizador.input, "no-global-input")}
                id="Totalizador_ValorIPI"
                readOnly disabled={somenteLeitura || props.desativarValorIPI}
                value={(globalMU.formatarValorNumerico(props.orcamento.ValorIPI, props.numeroCasasDecimais, false)) ?? ""} />
        </div>
    </>

    const percentualSeguroComponent = <>
        <span>
            % Seguro
        </span>
        <div>

            <InputNumerico
                onValorModificado={props.onPercentualSeguroModificado}
                id="Totalizador_PercentualSeguro"
                valor={props.orcamento.PercentualSeguroEntrega}
                classesInput={[estilosTotalizador.input]}
                numeroCasasDecimais={props.numeroCasasDecimais}
                disabled={somenteLeitura || props.desativarPercentualSeguro}
                selecionaValorOnFocus={true} />
        </div>
    </>

    const valorSeguroComponent = <>
        <span>
            Valor Seguro
        </span>
        <div>

            <InputNumerico
                onValorModificado={props.onValorSeguroModificado}
                id="Totalizador_ValorSeguro"
                valor={props.orcamento.ValorSeguroEntrega}
                classesInput={[estilosTotalizador.input]}
                numeroCasasDecimais={props.numeroCasasDecimais}
                disabled={somenteLeitura || props.desativarValorSeguro}
                selecionaValorOnFocus={true} />
        </div>
    </>

    const valorFreteComponent = <>
        {//445689
        props.trabalhaComFretePercentualNoOrcamento &&
        <> 
            <span
                id="Totalizador_LabelPercentualFrete"
                title="Veja parâmetros &#013;-Permite frete nas vendas para entrega na expedição&#013;-Permitir informar frete percentual no orçamento"
            >
                % Frete
            </span>
            <div>
                <InputNumerico
                    onValorModificado={props.onPercentualFreteModificado}
                    id="Totalizador_PercentualFrete_Input"
                    title="Veja parâmetros &#013;-Permite frete nas vendas para entrega na expedição&#013;-Permitir informar frete percentual no orçamento"
                    valor={props.orcamento.PercentualFrete}
                    classesInput={[estilosTotalizador.input]}
                    numeroCasasDecimais={props.numeroCasasDecimais}
                    disabled={somenteLeitura  || props.desativarValorFrete} // estou usando mesmo do "ValorFrete"
                    selecionaValorOnFocus={true} />
            </div> 
        </>}


        <span
        title="Veja parâmetros &#013;-Permite frete nas vendas para entrega na expedição&#013;-Permitir informar frete percentual no orçamento"
        >
            <u>V</u>alor Frete
        </span>
        <div>


            <InputNumerico
                onValorModificado={props.onValorFreteModificado}
                id="Totalizador_ValorFrete"
                title="Veja parâmetros &#013;-Permite frete nas vendas para entrega na expedição&#013;-Permitir informar frete percentual no orçamento"
                valor={props.orcamento.ValorFrete}
                classesInput={[estilosTotalizador.input]}
                numeroCasasDecimais={props.numeroCasasDecimais}
                disabled={somenteLeitura || props.desativarValorFrete}
                teclaDeAtalho="v"
                selecionaValorOnFocus={true} />
        </div>
    </>

    const aplicarCashback = <>
        <label htmlFor="Totalizador_AplicarDescontoCashback" style={{ cursor: 'pointer', fontWeight:'normal', textAlign: 'right' }}
            title="Veja parâmetro: Percentual máximo para uso de Cashback na venda">
            Aplicar Desconto Cashback
        </label>
        <div>
            <input className={clsx(estilosInputs.inputPadrao, estilosTotalizador.input, "no-global-input")}
                type="checkbox"
                id="Totalizador_AplicarDescontoCashback"
                disabled={somenteLeitura || props.desativarPercentualDescontoAcumulado}
                checked={props.orcamento.AplicaDescontoCashback ?? false}
                onChange={(e) => props.onAplicarDescontoCashback(e.target.checked)}
            />
        </div>
    </>

    const valorCashback = <>
        <span>
            Cashback Utilizado
        </span>
        <div id="Totalizador_ValorCashBackUtilizado">
           <span>{globalMU.formatarValorNumerico(props.orcamento.ValorCashbackUtilizado, 2, true)}</span>
        </div>
    </>

    const total = <>
        <span className={estilosTotalizador.legendaTotal}>
            {props.exibirDadosDeQuantidadePendente ? "Total faturado" : "Total"}
        </span>
        <div className={estilosTotalizador.total}>
            <span id="Totalizador_ValorTotal">
                {globalMU.formatarValorNumerico(props.orcamento.ValorTotal, 2, true)}
            </span>
        </div>
    </>

    const totalSolicitado = <>
        <span className={estilosTotalizador.legendaTotal} title="Veja parâmetro: Exibir quantidade pendente no orçamento">
            Total Solicitado
        </span>
        <div className={estilosTotalizador.total}>
            <span>
                {globalMU.formatarValorNumerico(props.orcamento.ValorTotalSolicitado, 2, true)}
            </span>
        </div>
    </>

    const totalPendencia = <>
        <span className={estilosTotalizador.legendaTotal}>
            Total Pendência
        </span>

        <div className={estilosTotalizador.total}>
            <span>
                {globalMU.formatarValorNumerico(props.orcamento.ValorTotalPendente, 2, true)}
            </span>
        </div>
    </>

    const motivoOptions = useMemo(() => (
        props.motivosDesconto?.map(m => 
            <option key={m.Codigo} value={m.Codigo}>{m.Motivo}</option>
        )
    ), [props.motivosDesconto])

    const canalDeVendaOptions = useMemo(() => ( // 422642
        props.listaCanalDeVenda?.filter(c => !c.Inativo || c.Id === idCanalDeVenda)?.map(c =>
            <option 
                key={c.Id} 
                value={c.Id}
                disabled={c.Inativo} // Desabilita opções inativas
                style={c.Inativo ? { color: 'gray', fontStyle: 'italic' } : {}}
            >
                {c.Descricao} {c.Inativo ? " (Inativo)" : ""}
            </option>
        )
    ), [props.listaCanalDeVenda])

    const motivoDesconto = <>
        <span
            id="Totalizador_MotivoDescontoLabel"
            title="Veja parâmetro: &#013;-Exige Motivo de Desconto no Orçamento e Caixa"
        >
            Motivo Desconto
        </span>
        <div style={{ minWidth: 0 }}>
            {/*
            <select disabled={somenteLeitura || props.desativarMotivoDesconto}
                name={"MotivoDesconto"} style={{ maxWidth: '100%', minWidth: '100%' }}
                id="Totalizador_MotivoDesconto"
                onChange={(e) => { 
                    // Atualiza o título com o texto da opção selecionada
                    const selectedOption = e.target.options[e.target.selectedIndex]


                    setCodigoMotivoDesconto(Number(e.target.value)); 
                    props.onMotivoDescontoSelecionado(Number(e.target.value))   
                    
                    e.target.title = selectedOption.text;

                    }
                }
                value={(codigoMotivoDesconto) ?? ""}>
                <option value={0} >-Selecione-</option>
                {/*                 
                {props.motivosDesconto?.map(m => <option key={m.Codigo} value={m.Codigo} >{m.Motivo}</option>)}
                 */} {/*
                 {motivoOptions}
            </select>
            */}
            <select 
                disabled={somenteLeitura || props.desativarMotivoDesconto}
                name={"MotivoDesconto"} 
                style={{ maxWidth: '100%', minWidth: '100%' }}
                id="Totalizador_MotivoDesconto"
                title={props.motivosDesconto?.find(m => m.Codigo === codigoMotivoDesconto)?.Motivo || ''}
                onChange={(e) => { 
                    const novoCodigo = Number(e.target.value);
                    setCodigoMotivoDesconto(novoCodigo); 
                    props.onMotivoDescontoSelecionado(novoCodigo);
                }}
                value={(codigoMotivoDesconto) ?? ""}>
                    <option value={0} >-Selecione-</option>
                    {motivoOptions}
            </select>
        </div>
    </>

    const iconePixPrazo = <> 
        <span>
        <FontAwesomeIcon 
            id="Totalizador_IconePixPrazo"// 414608
            style={{ textAlign: 'right', fontSize: 'xx-large', 
                color: props.orcamento.ElegivelParaEmailCobrancaPixPrazo 
                            ? 'darkblue' 
                            : 'gray'
             }}
            key="Totalizador_IconePixPrazo"
            title={props.orcamento.ElegivelParaEmailCobrancaPixPrazo 
                        ? "Habilitado para recebimento via PIX a Prazo" 
                        : "Esta venda não se enquadra nas condições para recebimento via PIX a Prazo."} // 414608
            
            icon={faPix as IconProp} //O cast para IconProp é necessário para contornar um problema de incompatibilidade de versão entre as bibliotecas do FontAwesome
        />
        </span>
        <span
            key="Totalizador_LabelPixPrazo"
            id="Totalizador_LabelPixPrazo" // 414608
            title={props.orcamento.ElegivelParaEmailCobrancaPixPrazo 
                        ? "Habilitado para recebimento via PIX a Prazo" 
                        : "Esta venda não se enquadra nas condições para recebimento via PIX a Prazo."} // 414608
            style={{textAlign: 'left', cursor: 'default',
                color: props.orcamento.ElegivelParaEmailCobrancaPixPrazo 
                            ? undefined
                            : 'gray'
            }}
        >
            Cobrança Pix
        </span>
    </>


    const comboBoxCanalDeVenda = <>
        <span
            id="Totalizador_CanalDeVendaLabel"
            title="Veja parâmetros: &#013;-Obrigatório informar canal de venda no orçamento&#013;-Canal de venda padrão do orçamento"
        >
            Canal de Venda
        </span>
        <div style={{ minWidth: 0 }}>
            <select disabled={somenteLeitura || props.editarCanalDeVenda === false || props.exibirCanalDeVenda === false || props.desativarCanalDeVenda}
                name={"CanalDeVenda"} style={{ maxWidth: '100%', minWidth: '100%' }}
                id="Totalizador_CanalDeVenda"
                title={props.listaCanalDeVenda?.find(m => m.Id === idCanalDeVenda)?.Descricao || ''}
                onChange={(e) => {
                    const id = Number(e.target.value);
                    // Verificar se a opção selecionada não está desabilitada
                    const selectedOption = props.listaCanalDeVenda?.find(c => c.Id === id);
                    if (selectedOption && !selectedOption.Inativo) {
                        setIdCanalDeVenda(id);
                        props.onCanalDeVendaSelecionado(id);
                    }
                }}
                value={(idCanalDeVenda) ?? ""}>
                <option value={0}>-Selecione-</option>
                 {canalDeVendaOptions}
            </select>
        </div>
    </>

    const valorServicosAgregadosComponent = <> 
    <span title="Serviço Adicional/Despesas &#013;Veja parâmetro: &#013;-Utiliza serviço agregado no orçamento?&#013;-Texto Padrão para serviços adicionais no orçamento">
        Serv.Adic/Despesas
    </span>
    <div>

    {/* 447380  */}
        <InputNumerico
            onValorModificado={props.onValorServicosAgregadosModificado}
            id="Totalizador_ServicosAgregados"
            valor={props.orcamento.ValorServicoAdicionalDespesa}
            classesInput={[estilosTotalizador.input]}
            numeroCasasDecimais={props.numeroCasasDecimais}
            disabled={somenteLeitura || props.desativarValorServicoAgregado}
            selecionaValorOnFocus={true} />
    </div>
    </>

    const camposLimiteCreditoCliente = (
    <>
        <span title="Veja parâmetro: &#013;-Informar saldo do limite de crédito do cliente na venda?">
            Saldo Limite Crédito
        </span>
        <span
            key="Totalizador_LimiteCreditoCliente"
            id="Totalizador_LimiteCreditoCliente"
            style={{ 
                cursor: "context-menu",
                textAlign: "right",
                fontWeight: "bold",
                color: LimiteCreditoCliente < 0 
                        ? "red"
                        : LimiteCreditoClientePendenciaFinanceira
                            ? "#FF8000"  
                            : "var(--mu-azul-marcador, blue)"
            }}
            title={
                (LimiteCreditoClienteBloqueado ? "Limite Bloqueado." : "") + 
                (LimiteCreditoClienteBloqueado && LimiteCreditoClientePendenciaFinanceira ? " | " : "") + 
                (LimiteCreditoClientePendenciaFinanceira ? "Pendência Financeira." : "")
            }
        >
            {globalMU.formatarValorNumerico(LimiteCreditoCliente, 2, false) 
                + (LimiteCreditoClienteBloqueado ? " (B)" : "") 
                + (LimiteCreditoClientePendenciaFinanceira ? " *" : "")
            } 
        </span>
    </>)

    return <div className={estilosTotalizador.container}>

        {dadosOrcamento}

        {titulo}

        <div className={clsx(estilosTotalizador.conteudoContainer)}>
            {quantidadeItens}

            {!props.separarNacionalImportado && valorMercadorias}

            {props.separarNacionalImportado && dadosNacional}

            {props.separarNacionalImportado && dadosImportado}

            {props.separarNacionalImportado && separador}

            {props.orcamento.TipoOrcamentoDescricao == "Venda" && props.orcamento.ValorDescontoIcms != null && valorDescontoIcms}
 

            {props.orcamento.TipoOrcamentoDescricao != "Transferências" && despesasInclusasComponent}

            {!props.separarNacionalImportado && <>
                {percentualDesconto}

                {campoValorDesconto}
            </>}

{/* movi para apos o total do pedido
            {props.exibirPercentualDescontoAcumulado && percentualDescontoAcumuladoComponent}

            {props.exibirDescontoAcumulado && descontoAcumulado}
*/}
            {props.orcamento.TipoOrcamentoDescricao == "Venda" //  && 428915/313149
                    && props.orcamento.ValorDescontoIcmsDesonerado != undefined && props.orcamento.ValorDescontoIcmsDesonerado != null
                    && props.orcamento.ValorDescontoIcmsDesonerado > 0 //  && 428915/313149
                    && valorDescontoIcmsDesonerado //  && 428915/313149
            }

            {props.orcamento.TipoOrcamentoDescricao == "Venda" && props.exibirAcrescimoFinanceiro && acrescimoFinanceiro}

            {props.exibirSubstituicao && substituicao}

            {props.exibirValorIPI && valorIPI}

            {percentualSeguroComponent}

            {valorSeguroComponent}

            {valorFreteComponent}
            
            {/* 
            
            
            
            
            
            ATENÇÃO: so incluia antes do total o que for participar do totalizador 
            
            
            
            
            
            
            */}
            {total}
            {props.exibirDadosDeQuantidadePendente && totalSolicitado}
            {props.exibirDadosDeQuantidadePendente && props.aceitarProdutoSemEstoque && totalPendencia}
          
            {props.exibirPercentualDescontoAcumulado && percentualDescontoAcumuladoComponent}

            {props.exibirDescontoAcumulado && descontoAcumulado}
            

            {props.exibirMotivoDesconto && motivoDesconto}
            {props.exibirCanalDeVenda // 422642
                && comboBoxCanalDeVenda // 422642
            }


            {props.orcamento.CodigoCliente > 7 && (props.orcamento.SaldoCashbackCliente > 0 || props.orcamento.ValorCashbackUtilizado > 0)   //438892
                    && aplicarCashback} 

            {props.orcamento.AplicaDescontoCashback 
                && valorCashback}

            {props.orcamento.TipoOrcamentoDescricao == "Venda" //447380
                && props.exibirValorServicosAgregados 
                && valorServicosAgregadosComponent
            }
            
            {props.orcamento.TipoOrcamentoDescricao == "Venda" // 448734
                && props.orcamento?.LimiteCreditoCliente != null 
                && camposLimiteCreditoCliente
            }


            {props.orcamento.TipoOrcamentoDescricao == "Venda" 
                && props.orcamento.AtivarRecebimentoPixAPrazo // 414608
                && valorParametroPorFilial("TRABALHA_COBRANCA_PIX_PRAZO") == "S" // 414608
                && iconePixPrazo // 414608 esse icone deve ser o ultimo no totalizador
            } 
            
            {/* 
            
            
            ATENÇÃO: so incluia antes do {total} o que for participar do totalizador 
            
            
            
            */}
        </div>
        {<section style={{ marginBottom: "40px" }} />}
    </div>
})
